/**
 * RadarSweep — animated concentric radar with a rotating sweep cone.
 * Purely decorative; sized by the container (aspect-square recommended).
 */
export default function RadarSweep({ className = "" }) {
  return (
    <div className={`relative aspect-square w-full ${className}`}>
      {/* concentric rings */}
      <div className="absolute inset-0 rounded-full border border-teal/25" />
      <div className="absolute inset-[8%] rounded-full border border-teal/20" />
      <div className="absolute inset-[20%] rounded-full border border-teal/15" />
      <div className="absolute inset-[34%] rounded-full border border-teal/12" />
      <div className="absolute inset-[50%] rounded-full border border-teal/10" />

      {/* crosshairs */}
      <div className="absolute inset-0">
        <div className="absolute left-0 right-0 top-1/2 h-px bg-teal/15" />
        <div className="absolute top-0 bottom-0 left-1/2 w-px bg-teal/15" />
      </div>

      {/* sweep cone */}
      <div
        className="absolute inset-0 origin-center animate-radar-sweep"
        style={{
          background:
            "conic-gradient(from 0deg, rgba(46,119,136,0.55) 0deg, rgba(46,119,136,0.15) 25deg, transparent 60deg, transparent 360deg)",
          borderRadius: "9999px",
          maskImage:
            "radial-gradient(circle at center, black 55%, transparent 78%)",
          WebkitMaskImage:
            "radial-gradient(circle at center, black 55%, transparent 78%)",
        }}
      />

      {/* blips */}
      <span className="absolute left-[62%] top-[38%] h-1.5 w-1.5 rounded-full bg-amber animate-pulse-soft" />
      <span className="absolute left-[30%] top-[56%] h-1.5 w-1.5 rounded-full bg-signalGreen animate-pulse-soft" />
      <span className="absolute left-[70%] top-[68%] h-1 w-1 rounded-full bg-mist/70" />

      {/* center dot */}
      <div className="absolute left-1/2 top-1/2 h-1.5 w-1.5 -translate-x-1/2 -translate-y-1/2 rounded-full bg-teal" />
    </div>
  );
}
